import { type ReactElement } from "react";
import Typewriter from "typewriter-effect";
import { Social } from "@/components";
import { useLanguage } from "@/context";
import Character from "@/assets/images/Character.svg";
import { socialData, t, tArray } from "@/data";

export const Hero = (): ReactElement => {
  const { lang } = useLanguage();

  return (
    <section id="hero" className="hero" aria-label={t(lang, "heroSection")}>
      <div className="container">
        <div className="role">
          <p>{t(lang, "heroGreeting")}</p>
          <Typewriter
            key={lang}
            options={{
              strings: [...tArray(lang, "typewriter")],
              autoStart: true,
              loop: true,
            }}
          />
          <span>{t(lang, "heroPassion")}</span>
        </div>
        <div className="character" aria-hidden="true">
          <img src={Character} alt="" width={400} height={400} />
        </div>
        <div className="description">
          <p></p>
          <Social data={socialData} />
        </div>
      </div>
    </section>
  );
};
